import Cookies from 'js-cookie';
import { LOGIN_AUTH_TOKEN_KEY } from '../constants/token';

const DEFAULT_EXPIRES_DAYS = 7;
const is_QR_LOGIN_COOKIE = 'isQRLogin';

export function saveAccessToken(token: string, expires: number = DEFAULT_EXPIRES_DAYS) {
  Cookies.set(LOGIN_AUTH_TOKEN_KEY, token, { expires });
}

export function loginWithToken(token: string, expires: number = DEFAULT_EXPIRES_DAYS) {
  saveAccessToken(token, expires);
  Cookies.set(is_QR_LOGIN_COOKIE, 'false');
}

export function loginWithQRToken(token: string, expires: number = DEFAULT_EXPIRES_DAYS) {
  saveAccessToken(token, expires);
  // Cookies.set(is_QR_LOGIN_COOKIE, 'true', {
  //   // session cookie 45 m
  //   expires: 45 / (24 * 60),
  // });
}

export const isQRLogin = () => {
  return Cookies.get(is_QR_LOGIN_COOKIE) === 'true';
};
